export default [{
    "type": "eFoil",
    "name": "eFoil",
    "img": "../assets/img/types/flite_air.webp",
    "description_small": 'eFoil - серф с электрическим двигателем и подводным крылом.',
    "description": 'eFoil - серф с электрическим двигателем и подводным крылом. eFoil отрывается от поверхности воды и катание превращается в полёт! Управляешь доской с помощью тела, а её скоростью (до 50км/ч) с помощью пульта в руке. И да, чтобы посёрфить не нужно ждать волны, грести до неё - можно сразу учиться и кайфовать.',
    "points": [
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2b',
            name: 'Морозово',
            img: '../assets/img/points/morozovo.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            description_full: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            enabled: true,
            open_chat:true
        },
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2d',
            name: 'Адлер',
            img: '../assets/img/points/adler.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            description_full: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            enabled: true,
            open_chat:true
        }
    ]
},{
    "type": "eJet",
    "name": "eJet",
    "img": "../assets/img/types/radinn_carve.webp",
    "description_small": 'eJet - электросерф с водомётным двигателем.',
    "description": 'eJet - электросерф с водомётным двигателем. eJet скользит по поверхности воды на скорости до 50 км/ч, которую ты сам контролируешь - пульт в руке! Не нужно ждать волну и грести до неё, остаётся только приноровиться и поймать баланс.',
    "points": [
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2b',
            name: 'Морозово',
            img: '../assets/img/points/morozovo.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            description_full: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            enabled: true,
            open_chat:true
        },
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2d',
            name: 'Адлер',
            img: '../assets/img/points/adler.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            description_full: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            enabled: true,
            open_chat:true
        }
    ]
},{
    "type": "sup-board",
    "name": "SUP-Board",
    "img": "../assets/img/types/sup_yellow.webp",
    "description_small": 'SUP – Stand Up Paddle, означает «Стоять с веслом».',
    "description": 'SUP – Stand Up Paddle, означает «Стоять с веслом». Кататься на САПе просто: человек стоит на доске и скользит по едет по воде, гребя длинным веслом.',
    "points": [
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2b',
            name: 'Морозово',
            img: '../assets/img/points/morozovo.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            description_full: 'Обучение и прокат электросёрфов и SUP-бордов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями. Услуги проката и инструктора доступны без проживания в отеле.<br>' +
                'Тарифы:<br>' +
                'SUP-борд - 1 час - 800₽<br>' +
                'Электросёрф - 20 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 3 500₽<br>' +
                'Электросёрф - 60 минут - 6 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>' +
                'Специальные тарифы на проживание в отеле и сауну.',
            enabled: true,
            open_chat:true
        },
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2d',
            name: 'Адлер',
            img: '../assets/img/points/adler.webp',
            types: {
                efoil: 2,
                ejet: 5,
                'sup-board': 2,
            },
            description_small: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            description_full: 'Обучение и прокат электросёрфов. Предоставим всю необходимую экипировку. Услуги профессионального инструктора включены в стоимость, научим за одно занятие. Оборудование ведущих мировых производителей Fliteboard (Австралия) и Radinn (Швеция).<br>' +
                'Снимем фото и видео для социальных сетей, чтобы Вы поделились своим восторгом с друзьями.<br>' +
                'Тарифы:<br>' +
                'Электросёрф - 10 минут - 2 500₽<br>' +
                'Электросёрф - 30 минут - 5 000₽<br>' +
                'Электросёрф - 60 минут - 9 000₽<br>' +
                'Абонементы на 3, 5 и 10 часов по сниженным ценам.<br>',
            enabled: true,
            open_chat:true
        }
    ]
},{
    "type": "yacht",
    "name": "Прогулка на яхте Романтика",
    "img": "../assets/img/points/romantika_3.jpg",
    "description_small": 'Модель: Carver 57 Имя: Romantika Класс: Бизнес Тип:моторная флайбриджная Вместимость: до 10 гостей Цена: от 15000 р час',
    "description": 'Модель: Carver 57<br>Имя: Romantika<br>Класс: Бизнес<br>Тип:моторная флайбриджная<br>Длина: 19 м<br>Ширина: 4.8 м<br>Год: 2001<br>Состояние: отличное<br>Вместимость: до 10 гостей<br>Цена: от 15000 р час<br>Оборудование: две полноценные каюты и маленькая с двухъярусной кроватью, два санузла (душ, туалет), кают-кампания с плитой и духовкой, полный набор посуды, электросёрфы, сапборды, тендер для высадки с труднодоступных местах, хороший звуковая система.  Яхта идеальна для корпоративов и семейных выходов.<br><br>Есть готовые туры в Геленджик, Абхазию, Крым.',
    "points": [
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be2c',
            name: 'Яхта Романтика',
            img: '../assets/img/points/romantika_3.jpg',
            types: {
                yacht: 1
            },
            description_small: 'Почасовой тариф от 3 часов до 10 чел - 15 000 рублей в час',
            description_full: '<b>Почасовой тариф от 3 часов до 10 чел - 15 000 рублей в час</b><br><br>Модель: Carver 57<br>Имя: Romantika<br>Класс: Бизнес<br>Тип:моторная флайбриджная<br>Длина: 19 м<br>Ширина: 4.8 м<br>Год: 2001<br>Состояние: отличное<br>Вместимость: до 10 гостей<br>Цена: от 15000 р час<br>Оборудование: две полноценные каюты и маленькая с двухъярусной кроватью, два санузла (душ, туалет), кают-кампания с плитой и духовкой, полный набор посуды, электросёрфы, сапборды, тендер для высадки с труднодоступных местах, хороший звуковая система.  Яхта идеальна для корпоративов и семейных выходов.<br><br>Есть готовые туры в Геленджик, Абхазию, Крым.',
            enabled: true,
            open_chat:false
        },
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be3c',
            name: 'Яхта Романтика',
            img: '../assets/img/points/romantika_day.jpg',
            types: {
                yacht: 1
            },
            description_small: 'Чартер в акватории Сочи/Адлер световой день в море до 10 чел - 100 000 рублей',
            description_full: '<b>Чартер в акватории Сочи/Адлер световой день в море до 10 чел - 100 000 рублей</b><br><br>Модель: Carver 57<br>Имя: Romantika<br>Класс: Бизнес<br>Тип:моторная флайбриджная<br>Длина: 19 м<br>Ширина: 4.8 м<br>Год: 2001<br>Состояние: отличное<br>Вместимость: до 10 гостей<br>Цена: от 15000 р час<br>Оборудование: две полноценные каюты и маленькая с двухъярусной кроватью, два санузла (душ, туалет), кают-кампания с плитой и духовкой, полный набор посуды, электросёрфы, сапборды, тендер для высадки с труднодоступных местах, хороший звуковая система.  Яхта идеальна для корпоративов и семейных выходов.<br><br>Есть готовые туры в Геленджик, Абхазию, Крым.',
            enabled: true,
            open_chat:false
        },
        {
            id: '1eadacdf-3d1c-4785-987b-392066d9be4c',
            name: 'Яхта Романтика',
            img: '../assets/img/points/romantika_sun.jpg',
            types: {
                yacht: 1
            },
            description_small: 'Чартер  в акватории Сочи/Адлер сутки (световой день в море до 10 человек + ночевка в порту до 4 чел) - 150 000 рублей',
            description_full: '<b>Чартер  в акватории Сочи/Адлер сутки (световой день в море до 10 человек + ночевка в порту до 4 чел) - 150 000 рублей</b><br><br>Модель: Carver 57<br>Имя: Romantika<br>Класс: Бизнес<br>Тип:моторная флайбриджная<br>Длина: 19 м<br>Ширина: 4.8 м<br>Год: 2001<br>Состояние: отличное<br>Вместимость: до 10 гостей<br>Цена: от 15000 р час<br>Оборудование: две полноценные каюты и маленькая с двухъярусной кроватью, два санузла (душ, туалет), кают-кампания с плитой и духовкой, полный набор посуды, электросёрфы, сапборды, тендер для высадки с труднодоступных местах, хороший звуковая система.  Яхта идеальна для корпоративов и семейных выходов.<br><br>Есть готовые туры в Геленджик, Абхазию, Крым.',
            enabled: true,
            open_chat:false
        },
    ]
},
]
